/** Command Deck MVP shell — feature flag and marketing boundaries. */

export const COMMAND_DECK_PREVIEW_ROUTE_PATH = '/command-deck/preview' as const

/** App router child path (no leading slash). */
export const COMMAND_DECK_PREVIEW_ROUTE_SEGMENT = 'command-deck/preview' as const

/** Live Command Deck — session-backed access state (not fixtures). */
export const COMMAND_DECK_LIVE_ROUTE_PATH = '/command-deck' as const

/** App router child path (no leading slash). */
export const COMMAND_DECK_LIVE_ROUTE_SEGMENT = 'command-deck' as const

export const COMMAND_DECK_LIVE_BANNER =
  'Command Deck — live access state from your authenticated session.'

export const MARKETING_BOOK_DEMO_URL = 'https://synktribe.com/book-demo'

/** Hosts where public Creator Beta preview is allowed (fixture data only). */
export const COMMAND_DECK_MARKETING_PREVIEW_HOSTS = ['app.synktribe.com'] as const

function isMarketingAppPreviewHost(): boolean {
  if (typeof window === 'undefined') return false
  return (COMMAND_DECK_MARKETING_PREVIEW_HOSTS as readonly string[]).includes(
    window.location.hostname,
  )
}

/**
 * Preview route uses fixtures — never live session grants.
 * Enabled in DEV, when VITE_COMMAND_DECK_PREVIEW=1, or on marketing app host.
 */
export function isCommandDeckPreviewEnabled(): boolean {
  if (import.meta.env.VITE_COMMAND_DECK_PREVIEW === '1') return true
  if (import.meta.env.VITE_COMMAND_DECK_PREVIEW === '0') return false
  if (import.meta.env.DEV) return true
  if (isMarketingAppPreviewHost()) return true
  return false
}

export const COMMAND_DECK_PREVIEW_BANNER =
  'Command Deck preview — planning shell. Access and progress shown from preview data.'

export const FORBIDDEN_COMMAND_DECK_COPY = [
  'sign in',
  'create account',
  'launch app',
  'go live',
  'publish automatically',
] as const
